<template>
  <div class="food-lib-container">
    <div class="food-lib-search">
      <h3 class="sidebar-title">Buscar alimentos</h3>
      <b-form-input
        v-model="searchInput"
        @input="changedInput"
        class="nft-search-box"
        type="text"
        placeholder="Buscar..."
      />
    </div>
    <div class="exercises-lib-content">
      <SpinnerBackdrop v-if="searching" size="4rem" thickness="0.4rem" variant="info" />
      <template>
        <draggable
          v-model="results"
          chosenClass="drag-chosen"
          ghostClass="drag-ghost"
          :sort="false"
          :clone="clone"
          :group="{name: 'portions', pull: 'clone', put: false}"
        >
          <div class="card-container" v-for="food_group in results" :key="food_group.id">          
            <b-card class="food-card">
              <span>{{food_group.name}}</span>
            </b-card>
            <b-button 
              class="food-button"
              @click="getFoodDetails(food_group.id)" 
              variant="outline-info"
            >
              <i class="wizard-icon ti-angle-right" />
            </b-button>
          </div>
        </draggable>
      </template>
    </div>
  </div>
</template>

<script>
import { keyMixin } from "../../../mixins/keyMixin";
import draggable from "vuedraggable";
import SpinnerBackdrop from "../../SpinnerBackdrop";

export default {
  name: "FoodLibrary",
  components: { SpinnerBackdrop, draggable },
  mixins: [keyMixin],
  props: {
    foodList: {
      type: Array,
      default: function(){
        return []
      },
    },
    foodDetails: {
      type: Object,
      default: function(){
        return {};
      },
    }
  },
  data: function() {
    return {
      searchInput: "",
      searchTimeout: null,
      searching: false,
      results: []
    };
  },
  mounted() {
    this.doSearch("");
  },
  methods: {
    changedInput: function(inputText) {
      this.searchInput = inputText.trim();
      if (this.searchInput.length >= 2 || this.searchInput=="") {
        clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(() => this.doSearch(this.searchInput), 300);
      }
    },
    clone: function(el) {
      return {
        id: this.random_key(),
        food_group: el, 
        quantity: "1.0"
      };
    },
    doSearch: function(searchText) {
      this.searching = true
      this.results = []
      let foods = this.foodList

      let filteredList = foods.filter(
        function (food) {
          return food.name.toLowerCase().includes(searchText.toLowerCase())
        }
      )
      this.results = filteredList
      this.searching = false
    },
    getFoodDetails (id) {
      this.$emit("get-food-details", id)
    }
  }
};
</script>

<style scoped lang="scss">
.food-lib-container {
  display: flex;
  flex-direction: column;
  height: 100%;

  & .food-lib-search {
    flex-grow: 0;
    padding-bottom: map_get($spacers, 4);
  }

  & .exercises-lib-content {
    flex-grow: 1;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 0 8px;
  }
}

.nft-search-box {
  margin-top: $spacer;
}

.card-container {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: stretch;
  margin: map_get($spacers, 3) 0;
}

.food-card {
  width: 100%;
  height: 100%;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  text-align: center;
  transition-property: box-shadow, background-color;
  transition-duration: 0.15s;
  cursor: move;

  &:hover {
    background-color: $hover-background-color;
  }

  & .card-body {
    padding: 8px;
  }
}

.food-button {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}

.drag-chosen {
  z-index: $zindex-tooltip;
  cursor: move;
  background-color: rgba(theme-color("primary"), 0.05);
  box-shadow: 1px 1px 4px 0 rgba(theme-color-level("primary", 10), 0.5);
}
</style>